import Title from './typography/title';
import { Status, Substatus } from '../types';

type Props = {
  substatus: Substatus<Status>;
};

export default function SubstatusLabel({ substatus }: Props) {
  return <Title text={getLabel(substatus)} />;
}
function getLabel(substatus: Substatus<Status>) {
  switch (substatus) {
    case 'delivered':
      return 'Pedido entregado';
    case 'return_to_sender':
    case 'package_undeliverable':
      return 'Pedido devuelto al vendedor';
    case 'rejected_consumer_validation':
    case 'definitive_pickup_failed_attempt':
      return 'Pedido cancelado';
    case 'order_placed':
      return 'Procesando pedido';
    case 'manual_payment_pending':
      return 'Por favor realiza tu pago';
    case 'pending_consumer_validation':
      return 'Por favor valida tu identidad';
    case 'merchant_preparing_order':
      return 'Revisa detalles para un estimado';
    default:
      return '';
  }
}
